import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  cursor: pointer;

  .blog-title {
    color: ${props => props.theme.white};
    font-size: ${props => props.theme.p1b.fs};
    font-family: ${props => props.theme.p2m.ff};
    margin-top: 12px;
    /* text-shadow: 0px 2px 7px rgba(0, 0, 0, 0.342002); */
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tags {
    flex: 1;
    display: flex;
    margin-left: 24px;
    justify-content: flex-end;
    color: ${props => props.theme.textDark};
    p {
      text-align: right;
      margin: 0px 4px;
      font-family: ${props => props.theme.p3r.ff};
      font-size: ${props => props.theme.p3r.fs};
    }
  }

  .blog-content {
    width: 94%;
    font-family: ${props => props.theme.p1r.ff};
    font-size: ${props => props.theme.p2r.fs};
    color: ${props => props.theme.white};
  }
`;

export const BlogDetails = styled.div`
  .header {
    display: flex;
    margin: 14px 0px;
    margin-bottom: 20px;
    align-items: center;
  }
  .slider-ish {
    display: flex;
    background: ${props => props.theme.buttonPrimaryColor};
    width: fit-content;
    padding-left: 0px;
    border-radius: 24px;

    span {
      color: ${props => props.theme.white};
      padding: 4px 12px;
      font-family: ${props => props.theme.p2m.ff};

      &:first-child {
        width: fit-content;
        background: ${props => props.theme.highlight};
        border-radius: 12px;
        padding: 4px 24px;
      }

      p {
        font-family: ${props => props.theme.p3b.ff};
        font-size: ${props => props.theme.p3r.fs};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .author p {
    padding: 0px 12px;
    max-width: 150px;
  }

  @media (max-width: 1024px) {
    .author p {
      max-width: 100px;
    }
  }
`;

export const BlogImage = styled.div`
  .blog-img {
    width: 100%;
    height: 182px;
    object-fit: cover;
  }
`;
